<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Segmentos</h1>
    <div class="mb-6 flex justify-between items-center">
      <text-input v-model="form.search" class="w-full max-w-md mr-4" label="Descrição" />
      <inertia-link class="btn-indigo" :href="route('empresaatividade.create')">
        <span>Criar</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">ID</th>
          <th class=" pt-6 pb-4">Descrição</th>
        </tr>

        <tr v-for="row in pagination.data" :key="row.idEmpresaAtividade" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4 flex items-center focus:text-indigo-500">
            {{ row.idEmpresaAtividade }}
          </td>
          <td class="border-t ">
            {{ row.descricao }}
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('empresaatividade.edit', row.idEmpresaAtividade)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="pagination.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nenhum segmento encontrado.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="pagination.links" :query="filters" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import debounce from 'lodash/debounce'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import TextInput from '../../Shared/TextInput.vue'
export default {
  metaInfo: { title: 'Segmentos' },
  components: {
    Icon,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    pagination: Object,
  },
  data() {
    return {
      options: [],
      selectedCidade:'',
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        cidade: this.filters.cidade,
        ultimoAcesso: this.filters.ultimoAcesso,
        searchCidade: this.filters.searchCidade,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: debounce(function() {
        this.$inertia.get(this.route('empresaatividade'), pickBy(this.form), { preserveState: true })
      }, 500),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    onSearch(search) {
      if(search.length) {
        this.form.searchCidade=search
      }
    },

  },


}
</script>
